import Chevron from "../Chevron/Chevron"
import BottomSheet from "../BottomSheet/BottomSheet"
import BottomSheetHeader from "../BottomSheetHeader/BottomSheetHeader"
import SearchBar from "../SearchBar/SearchBar"
import ChecklistIcon from "../ChecklistIcon/ChecklistIcon"
import { useState } from "react"
import { PRIMARY } from "../../styles/colors"
import React from "react"
import {
  TriggerButton,
  SelectedContent,
  OptionIcon,
  SelectedLabel,
  PlaceholderText,
  ChevronWrapper,
  OptionItem,
  OptionContent,
  OptionTextContainer,
  OptionLabel,
  OptionSubtitle
} from "./BottomSheetDropdown.styles"

export type BottomSheetDropdownOption = {
  label: string
  iconUrl?: string
  subtitle?: string
}

export type BottomSheetDropdownProps = {
  placeholder: string
  options: BottomSheetDropdownOption[]
  value?: BottomSheetDropdownOption
  onChange?: (value: BottomSheetDropdownOption) => void
  showSearch?: boolean
}

export default function BottomSheetDropdown({
  placeholder,
  options,
  value,
  onChange,
  showSearch = true
}: BottomSheetDropdownProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const handleSelect = (option: BottomSheetDropdownOption) => {
    onChange?.(option)
    setIsOpen(false)
    setSearchQuery('')
  }

  const filteredOptions = searchQuery
    ? options.filter(option =>
      option.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
      option.subtitle?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : options

  return (
    <>
      <TriggerButton onClick={() => setIsOpen(true)}>
        {value && (
          <SelectedContent $hasIcon={!!value.iconUrl}>
            {value.iconUrl && (
              <OptionIcon
                src={value.iconUrl}
                alt={value.label}
              />
            )}
            <SelectedLabel>
              {value.label}
            </SelectedLabel>
          </SelectedContent>
        )}
        {!value && (
          <PlaceholderText>
            {placeholder}
          </PlaceholderText>
        )}
        <ChevronWrapper>
          <Chevron
            direction="down"
            color={PRIMARY}
            size={8}
            strokeWidth={2}
          />
        </ChevronWrapper>
      </TriggerButton>

      <BottomSheet
        isOpen={isOpen}
        header={
          showSearch ? (
            <BottomSheetHeader>
              <SearchBar
                value={searchQuery}
                onChange={(value) => setSearchQuery(value)}
              />
            </BottomSheetHeader>
          ) : (
            <BottomSheetHeader />
          )
        }
        showCloseButton={showSearch}
        onClose={() => {
          setIsOpen(false)
          setSearchQuery('')
        }}
      >
        {filteredOptions.map((option, index) => {
          const isSelected = value?.label === option.label
          const hasIcon = !!option.iconUrl
          const isSimpleMode = !showSearch && !hasIcon
          const showCheckmark = isSimpleMode && isSelected
          return (
            <React.Fragment key={index}>
              <OptionItem
                onClick={() => handleSelect(option)}
                $isLast={index === filteredOptions.length - 1}
                $hasIcon={hasIcon}
              >
                <OptionContent>
                  {option.iconUrl && (
                    <OptionIcon
                      src={option.iconUrl}
                      alt={option.label}
                    />
                  )}
                  <OptionTextContainer>
                    <OptionLabel>
                      {option.label}
                    </OptionLabel>
                    {option.subtitle && (
                      <OptionSubtitle>
                        {option.subtitle}
                      </OptionSubtitle>
                    )}
                  </OptionTextContainer>
                </OptionContent>
                {showCheckmark && <ChecklistIcon size={16} strokeWidth={1.5} />}
                {!isSimpleMode && <Chevron direction="right" color={PRIMARY} size={6} strokeWidth={2} />}
              </OptionItem>
            </React.Fragment>
          )
        })}
      </BottomSheet>
    </>
  )
}
